import React, { Fragment, useEffect } from "react";

import { IconButton } from "../../controls";
import { Box } from "../../layout";
import Overlay from "../Overlay";
import ModalContent, { Props as ContentProps } from "./components/ModalContent";

type Props = ContentProps & {
  modalIsPartOfJourney?: boolean;
  scrollableBackground?: boolean;
  onCloseClick?: () => void;
};

export default function Modal({
  onCloseClick,
  children,
  modalIsPartOfJourney,
  scrollableBackground = false,
  fullscreen = true,
  ...contentProps
}: Props) {
  useEffect(() => {
    if (!scrollableBackground && document.body && document.body.style) {
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = "auto";
      };
    }
    return;
  }, []);

  const modalContent = (
    <ModalContent fullscreen={fullscreen} {...contentProps}>
      {onCloseClick && (
        <Box position="absolute" top="0" right="0">
          <IconButton
            iconName="cross"
            accessibilityLabel="Close modal"
            onClick={onCloseClick}
            size="medium"
            tone="neutral"
            blend
          />
        </Box>
      )}
      {children}
    </ModalContent>
  );

  return modalIsPartOfJourney ? (
    modalContent
  ) : (
    <Fragment>
      <Overlay
        onCloseClick={onCloseClick}
        position={fullscreen ? "fixed" : "absolute"}
      />
      {modalContent}
    </Fragment>
  );
}
